import React from 'react';

export function Header() {
  return (
    <header className="text-center py-16 px-4 bg-gradient-to-r from-pink-100 to-rose-100 text-gray-800">
      <h1 className="text-4xl md:text-5xl font-bold mb-4">
        Your Go-To Wedding Planning Platform is Coming Soon!
      </h1>
      <h2 className="text-xl md:text-2xl max-w-3xl mx-auto">
        Whether you're planning your dream wedding or showcasing your services, join our waiting list and be the first to experience the future of wedding planning.
      </h2>
    </header>
  );
}